// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__1pIKM","vLegacy":"SelectSecondary_vLegacy__2KZ18","error":"SelectSecondary_error__-n8Hn","disabled":"SelectSecondary_disabled__1Yi7D"};